import React from 'react';

const BibleReferenceModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  
  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        padding: '20px',
        overflowY: 'auto'
      }}
      onClick={onClose}
    >
      <div 
        style={{
          background: 'white',
          borderRadius: '16px',
          maxWidth: '900px',
          width: '100%',
          maxHeight: '90vh',
          overflow: 'auto',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          margin: '20px auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Sticky Header */}
        <div style={{
          padding: '24px',
          borderBottom: '2px solid #e2e8f0',
          position: 'sticky',
          top: 0,
          background: 'white',
          zIndex: 1,
          borderRadius: '16px 16px 0 0'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 style={{ margin: 0, color: 'var(--deep-blue)', fontSize: '1.75rem', fontWeight: '700' }}>
              📖 Bible Reference Guide
            </h2>
            <button
              onClick={onClose}
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: '8px',
                borderRadius: '8px',
                fontSize: '1.5rem',
                color: '#64748b'
              }}
            >
              ×
            </button>
          </div>
        </div>
        
        {/* Summary Stats */}
        <div style={{ padding: '24px' }}>
          <div style={{
            padding: '20px',
            background: 'linear-gradient(135deg, rgba(74, 144, 226, 0.05), rgba(74, 144, 226, 0.1))',
            borderRadius: '12px',
            textAlign: 'center',
            marginBottom: '24px'
          }}>
            <h3 style={{ margin: '0 0 12px 0', color: 'var(--deep-blue)' }}>📊 Quick Stats</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px', fontSize: '0.95rem' }}>
              <div>
                <div style={{ fontWeight: '700', fontSize: '1.5rem', color: 'var(--primary-blue)' }}>66</div>
                <div style={{ color: '#64748b' }}>Total Books</div>
              </div>
              <div>
                <div style={{ fontWeight: '700', fontSize: '1.5rem', color: 'var(--primary-blue)' }}>1,189</div>
                <div style={{ color: '#64748b' }}>Chapters</div>
              </div>
              <div>
                <div style={{ fontWeight: '700', fontSize: '1.5rem', color: 'var(--primary-blue)' }}>31,102</div>
                <div style={{ color: '#64748b' }}>Verses</div>
              </div>
            </div>
          </div>

          {/* OLD TESTAMENT */}
          <div style={{ marginBottom: '32px' }}>
            <h3 style={{ 
              color: 'var(--deep-blue)', 
              fontSize: '1.25rem', 
              fontWeight: '700',
              marginBottom: '16px',
              paddingBottom: '8px',
              borderBottom: '2px solid var(--primary-blue)'
            }}>
              📜 Old Testament (39 Books)
            </h3>

            {/* Law - Torah */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{ color: 'var(--accent-teal)', fontSize: '1rem', fontWeight: '600', marginBottom: '12px' }}>
                ⚖️ The Law (Torah) - 5 Books
              </h4>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: '8px',
                fontSize: '0.9rem',
                paddingLeft: '16px'
              }}>
                <div>📖 Genesis (50 chapters)</div>
                <div>📖 Exodus (40 chapters)</div>
                <div>📖 Leviticus (27 chapters)</div>
                <div>📖 Numbers (36 chapters)</div>
                <div>📖 Deuteronomy (34 chapters)</div>
              </div>
            </div>

            {/* History */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{ color: 'var(--accent-teal)', fontSize: '1rem', fontWeight: '600', marginBottom: '12px' }}>
                📚 History - 12 Books
              </h4>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: '8px',
                fontSize: '0.9rem',
                paddingLeft: '16px'
              }}>
                <div>📖 Joshua (24 chapters)</div>
                <div>📖 Judges (21 chapters)</div>
                <div>📖 Ruth (4 chapters)</div>
                <div>📖 1 Samuel (31 chapters)</div>
                <div>📖 2 Samuel (24 chapters)</div>
                <div>📖 1 Kings (22 chapters)</div>
                <div>📖 2 Kings (25 chapters)</div>
                <div>📖 1 Chronicles (29 chapters)</div>
                <div>📖 2 Chronicles (36 chapters)</div>
                <div>📖 Ezra (10 chapters)</div>
                <div>📖 Nehemiah (13 chapters)</div>
                <div>📖 Esther (10 chapters)</div>
              </div>
            </div>

            {/* Wisdom */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{ color: 'var(--accent-teal)', fontSize: '1rem', fontWeight: '600', marginBottom: '12px' }}>
                💡 Wisdom & Poetry - 5 Books
              </h4>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: '8px',
                fontSize: '0.9rem',
                paddingLeft: '16px'
              }}>
                <div>📖 Job (42 chapters)</div>
                <div>📖 Psalms (150 chapters)</div>
                <div>📖 Proverbs (31 chapters)</div>
                <div>📖 Ecclesiastes (12 chapters)</div>
                <div>📖 Song of Solomon (8 chapters)</div>
              </div>
            </div>

            {/* Major Prophets */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{ color: 'var(--accent-teal)', fontSize: '1rem', fontWeight: '600', marginBottom: '12px' }}>
                🎺 Major Prophets - 5 Books
              </h4>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: '8px',
                fontSize: '0.9rem',
                paddingLeft: '16px'
              }}>
                <div>📖 Isaiah (66 chapters)</div>
                <div>📖 Jeremiah (52 chapters)</div>
                <div>📖 Lamentations (5 chapters)</div>
                <div>📖 Ezekiel (48 chapters)</div>
                <div>📖 Daniel (12 chapters)</div>
              </div>
            </div>

            {/* Minor Prophets */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{ color: 'var(--accent-teal)', fontSize: '1rem', fontWeight: '600', marginBottom: '12px' }}>
                📯 Minor Prophets - 12 Books
              </h4>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: '8px',
                fontSize: '0.9rem',
                paddingLeft: '16px'
              }}>
                <div>📖 Hosea (14 chapters)</div>
                <div>📖 Joel (3 chapters)</div>
                <div>📖 Amos (9 chapters)</div>
                <div>📖 Obadiah (1 chapter)</div>
                <div>📖 Jonah (4 chapters)</div>
                <div>📖 Micah (7 chapters)</div>
                <div>📖 Nahum (3 chapters)</div>
                <div>📖 Habakkuk (3 chapters)</div>
                <div>📖 Zephaniah (3 chapters)</div>
                <div>📖 Haggai (2 chapters)</div>
                <div>📖 Zechariah (14 chapters)</div>
                <div>📖 Malachi (4 chapters)</div>
              </div>
            </div>
          </div>

          {/* NEW TESTAMENT */}
          <div>
            <h3 style={{ 
              color: 'var(--deep-blue)', 
              fontSize: '1.25rem', 
              fontWeight: '700',
              marginBottom: '16px',
              paddingBottom: '8px',
              borderBottom: '2px solid var(--primary-blue)'
            }}>
              ✨ New Testament (27 Books)
            </h3>

            {/* Gospels */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{ color: 'var(--accent-teal)', fontSize: '1rem', fontWeight: '600', marginBottom: '12px' }}>
                📰 The Gospels - 4 Books
              </h4>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: '8px',
                fontSize: '0.9rem',
                paddingLeft: '16px'
              }}>
                <div>📖 Matthew (28 chapters)</div>
                <div>📖 Mark (16 chapters)</div>
                <div>📖 Luke (24 chapters)</div>
                <div>📖 John (21 chapters)</div>
              </div>
            </div>

            {/* History */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{ color: 'var(--accent-teal)', fontSize: '1rem', fontWeight: '600', marginBottom: '12px' }}>
                🔥 Church History - 1 Book
              </h4>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: '8px',
                fontSize: '0.9rem',
                paddingLeft: '16px'
              }}>
                <div>📖 Acts (28 chapters)</div>
              </div>
            </div>

            {/* Paul's Letters */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{ color: 'var(--accent-teal)', fontSize: '1rem', fontWeight: '600', marginBottom: '12px' }}>
                ✉️ Paul's Letters - 13 Books
              </h4>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: '8px',
                fontSize: '0.9rem',
                paddingLeft: '16px'
              }}>
                <div>📖 Romans (16 chapters)</div>
                <div>📖 1 Corinthians (16 chapters)</div>
                <div>📖 2 Corinthians (13 chapters)</div>
                <div>📖 Galatians (6 chapters)</div>
                <div>📖 Ephesians (6 chapters)</div>
                <div>📖 Philippians (4 chapters)</div>
                <div>📖 Colossians (4 chapters)</div>
                <div>📖 1 Thessalonians (5 chapters)</div>
                <div>📖 2 Thessalonians (3 chapters)</div>
                <div>📖 1 Timothy (6 chapters)</div>
                <div>📖 2 Timothy (4 chapters)</div>
                <div>📖 Titus (3 chapters)</div>
                <div>📖 Philemon (1 chapter)</div>
              </div>
            </div>

            {/* General Letters */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{ color: 'var(--accent-teal)', fontSize: '1rem', fontWeight: '600', marginBottom: '12px' }}>
                📬 General Letters - 8 Books
              </h4>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: '8px',
                fontSize: '0.9rem',
                paddingLeft: '16px'
              }}>
                <div>📖 Hebrews (13 chapters)</div>
                <div>📖 James (5 chapters)</div>
                <div>📖 1 Peter (5 chapters)</div>
                <div>📖 2 Peter (3 chapters)</div>
                <div>📖 1 John (5 chapters)</div>
                <div>📖 2 John (1 chapter)</div>
                <div>📖 3 John (1 chapter)</div>
                <div>📖 Jude (1 chapter)</div>
              </div>
            </div>

            {/* Prophecy */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{ color: 'var(--accent-teal)', fontSize: '1rem', fontWeight: '600', marginBottom: '12px' }}>
                🌟 Prophecy - 1 Book
              </h4>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                gap: '8px',
                fontSize: '0.9rem',
                paddingLeft: '16px'
              }}>
                <div>📖 Revelation (22 chapters)</div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer with Close Button */}
        <div style={{
          padding: '24px',
          borderTop: '2px solid #e2e8f0',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '12px 32px',
              background: 'linear-gradient(135deg, var(--deep-blue), var(--accent-teal))',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default BibleReferenceModal;
